import "../scss/style.scss";

/*------------------------------------------
	common
------------------------------------------*/
// SP menu
$(function() {
	$('.js-nav-btn').on('click',function() {
		$('.js-nav').fadeToggle();
		$(this).toggleClass('is-close');
	});
	$('.js-nav a[href^="#"]').on('click',function() {
		$('.js-nav').fadeOut();
		$('.js-nav-btn').removeClass('is-close');
	});
});

// child menu
$(function() {
	$('.js-nav-parent').on('click', function() {
		$('+ .js-nav-child', this).slideToggle();
		$(this).toggleClass('is-open');
	});
});
